"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = exports.ToggleSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const ToggleSwitch = ({ value, onChange, className, theme = "p100", disabled, }) => {
    const [state, setState] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        setState(() => value);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)(exports.Toggle, { className: className, theme: theme, active: value, disabled: disabled, onClick: () => {
            setState(!state);
            if (onChange)
                onChange(!state);
        } }, void 0));
};
exports.ToggleSwitch = ToggleSwitch;
const Toggle = ({ active, className, theme = "p100", onClick, disabled, }) => {
    const handleClick = (0, react_1.useCallback)(() => {
        if (onClick && !disabled)
            onClick();
    }, [onClick, disabled]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, lib_1.classnames)("toggle-switch", className), onClick: handleClick }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", className: "toggle-switch__input", checked: active, disabled: disabled }, void 0), (0, jsx_runtime_1.jsx)("span", { className: (0, lib_1.bem)("toggle-switch__switch", `--${theme}`, (0, lib_1.use)(disabled, "--disabled")) }, void 0)] }), void 0));
};
exports.Toggle = Toggle;
//# sourceMappingURL=ToggleSwitch.js.map